import {animationStore, PlayState} from 'stores/animationStore';
import {useEffect, useState} from 'react';
import {prettifyName} from 'helpers/misc';

import {PauseCircleIcon, PlayCircleIcon} from 'assets/Icons';
import './AnimationButtons.css';

const AnimationButton = ({clip}) => {
  const toggleClipActivation = animationStore(state => state.toggleClipActivation);
  const clipStates = animationStore(state => state.clipStates);

  const [isPlaying, setIsPlaying] = useState(false);
  const [progression, setProgression] = useState(0);
  useEffect(() => {
    const clipState = clipStates.find(clipState => clipState.clipName === clip.name);
    if (clipState) {
      setIsPlaying(clipState.playState === PlayState.Playing);
      setProgression(Math.round(clipState.progression * 1000) / 10);
    }
  }, [clipStates, clip.name]);

  const toggleAnimationState = () => toggleClipActivation(clip);

  return (
    <div className={`button ${isPlaying ? 'playing' : ''}`} onClick={toggleAnimationState}>
      {isPlaying ? 'Pause ' : 'Play '} {prettifyName(clip.name)}
      <span className={'icon'}>
        {/* Displaying play icon when animation is paused to show possible action */}
        {isPlaying ? <PauseCircleIcon/> : <PlayCircleIcon/>}
      </span>
      <div className={'progression'} style={{width: progression + '%'}}/>
    </div>
  );

};

const AnimationButtons = () => {
  const clips = animationStore(state => state.clips);

  return (
    <div className="button-container">
      {clips?.map(clip => <AnimationButton key={clip.uuid} clip={clip}/>)}
    </div>
  );
};

export default AnimationButtons;